<template>
  <div class="container-fluid new_Header" v-if="!isLoading">
    <div class="row nav_Breadcrumb">
      <div class="col">
        <nav>
          <ol class="breadcrumb">
            <li class="breadcrumb-item mx-3"><router-link  to="/">{{$t('myreservations.breadcrumb_1')}}</router-link></li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="active mx-3 almarai-bold" aria-current="page">{{$t('myreservations.breadcrumb_2')}}</li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <div class="container pt-3">
    <div class="row">
      <div class="col">
        <errorAlert v-if="hasError" :alertMessage="message" />
        <mainloader v-if="isLoading" />
        <div v-else class="row">
          <div class="col">
            <div class="row">
              <div class="col-12 mb-4" v-for="(row,index) in rows" :key="index">
              <router-link :to="'/propReservationDetails/'+row.id">
                <div class="card br-radius-16">
                  <div class="card-body padding-10">
                    <div class="row">
                      <div class="col-4 col-md-2 button-center">
                        <div class="position-R">
                          <swiper v-if="row.Property.mediaFiles.length" :modules="[Pagination, Navigation]" 
                            :pagination="{ clickable: true }" :navigation="false"  
                            > 
                            <swiper-slide v-for="(val, index) in row.Property.mediaFiles" :key="index">
                              <img :src="MEDIA_URL+val.thumbnail" alt="Slide Image" class="w-100 br-radius" />
                            </swiper-slide>
                          </swiper>
                          <div v-else>
                            <img src="/assets/images/defaultImage.jpg" class="w-100br-radius" alt="">
                          </div>
                        </div>
                      </div>
                      <div class="col-8 col-md-10 button-center">
                        <div class="row justify-content-center">
                          <div class="col-12 col-md-auto almarai-regular font-12">
                            <div class="reservation-style mb-2 space">
                              <!-- <span class="">{{(row.purpose == 'for_rent') ? $t('rent') : (row.purpose == 'for_sale') ? $t('sale')  : $t('investment') }}</span> -->
                              {{row.Property.PropertyType.name}}
                            </div>
                          </div>
                          <div class="col almarai-regular font-12">
                            <div class="reservation-style">{{items.reservationStatus[row.status]}}</div>
                          </div>
                        </div>
                        <div class="almarai-regular">{{ row.Property.title }}</div>
                        <div class="row">
                          <div class="col-6 col-md-auto content-center">
                            <div class="d-flex">
                              <i class="fa-solid fa-location-dot gray-color"></i>
                              <div class="small-Font mx-1">{{ row.Property.City.name }}</div>
                              <span class="small-Font mx-1">{{ row.Property.Neighborhood.name }}</span>
                            </div>
                          </div>
                          <div class="col-6 col-md-auto button-center text-direction">
                            <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
                            <span class="green-color-F">{{ row.Property.price }}</span>
                            <!-- <span class="mx-1 green-color-F">{{$t('currency')}}</span> -->
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                    </div>
                    <!-- <hr class="border-color-w"> -->
                    <!-- <div class="row space">
                      <div class="col-4">
                        <span class="green-color-F">{{ row.Property.price }}</span>
                        <span class="mx-1 green-color-F">ر.س</span>
                      </div>
                      <div class="col-4">
                        <span><img :src="MEDIA_URL+item.countedIcons.roomsCount.path" alt=""></span>
                        <span class="mx-1">{{ row.Property.roomsCount }}</span>
                        <span>{{ item.countedIcons.roomsCount.name }}</span>
                      </div>
                      <div class="col-4 border-end">
                        <span><img :src="MEDIA_URL+item.countedIcons.bathrooms.path" alt=""></span>
                        <span class="mx-1">{{ row.Property.bathrooms }}</span>
                        <span>{{ item.countedIcons.bathrooms.name }}</span>
                      </div>
                    </div> -->
                  </div>
                </div>
              </router-link>
          </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="!rows.length">
          <div class="col">
            <div class="row">
              <div  class="col">
                <div class="text-center pb-3">
                  <img src="/assets/images/icons/Frame-48.png" class="img-fluid" alt="">
                </div>
                <div class="almarai-bold pt-2 text-center">{{$t('myreservations.title_1')}}</div>
                <div class="text-center almarai-regular gray-color fonttext-14">
                  <span>{{$t('myreservations.title_2')}}</span>
                </div>
              </div>
            </div>

            <div class="row py-4 justify-content-center">
              <div class="col-6 text-center py-3">
                <router-link to="/">
                  <button class="submit-button form-control almarai-bold">{{$t('myreservations.button')}}</button>
                </router-link>
              </div>  
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation } from "swiper/modules";
import { mapGetters } from "vuex";
export default {
  name: 'myreservations',
  data(){
    return{
      hasError: false,
      message: "",
      isLoading: false,
      items: {},
      rows: [],
      PropertyType: {},
      userLang: 'ar',
    }
  },
  setup() {
    return {
      Pagination,
      Navigation,
    };
  },
  components: { Swiper, SwiperSlide },
  computed:{
    ...mapGetters(['MEDIA_URL'])
  },
  methods:{
    reservationList(){
      this.isLoading = true;
      this.$http.get("/api/propReservation/list").then(res => {
        // console.log(res);
        this.items = res.data;
        this.rows = this.items.rows;
        // this.PropertyType = res.data.rows.Property.PropertyType;
        this.isLoading = false;
      }).catch(err => {
        // console.log(err);
        this.isLoading = false;
        this.message = this.$globalError(err);
        this.hasError = true;
        window.scroll(0,0);
      });
    }
  },
  created(){
    this.reservationList();
    this.userLang = localStorage.getItem('lang') ?? 'ar';
  }
}
</script>
